var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showComponent)?_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.createFutureAddress}},[_vm._v(" Toekomstig adres aanmaken")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }